import { createSlice } from "@reduxjs/toolkit";
import {
    getActiveAnnouncements,
    dismissAnnouncement,
} from "../actions/announcementActionsHelper";
import { announcementsObject } from "../stateObject/announcementsObject";

const initialState = announcementsObject;

const announcementSlice = createSlice({
    name: "announcement",
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
            state.dismissError = null;
        },
        resetState: () => {
            return initialState;
        },
    },
    extraReducers: (builder) => {
        builder
            // Get active announcements
            .addCase(getActiveAnnouncements.request, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getActiveAnnouncements.success, (state, action) => {
                state.isLoading = false;
                state.announcements = action.payload.announcements || [];
                state.error = null;
            })
            .addCase(getActiveAnnouncements.failed, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })

            // Dismiss announcement
            .addCase(dismissAnnouncement.request, (state) => {
                state.isDismissing = true;
                state.dismissError = null;
            })
            .addCase(dismissAnnouncement.success, (state, action) => {
                state.isDismissing = false;
                state.announcements = state.announcements.filter(
                    announcement => announcement.id !== action.payload
                );
                state.dismissError = null;
            })
            .addCase(dismissAnnouncement.failed, (state, action) => {
                state.isDismissing = false;
                state.dismissError = action.payload;
            });
    },
});

export const { clearError, resetState } = announcementSlice.actions;
export default announcementSlice.reducer;
